

const privacyPolicy = {

privacyPolicy: {
  meta: {
    title: "{{appName}} — Datenschutzerklärung",
    closeAria: "Schließen",
    closeTitle: "Schließen",
    lastUpdated: "Zuletzt aktualisiert: {{date}}",
    subtitle:
      "Diese Datenschutzerklärung erläutert, wie {{companyName}} personenbezogene Daten erhebt, verwendet, speichert, schützt und weitergibt, wenn du {{appName}} nutzt.",
    top: "↑ Nach oben",
    print: "Datenschutzerklärung drucken / als PDF speichern",
    contact: "Kontakt",
    copyright: "© {{year}} {{companyName}}. Alle Rechte vorbehalten.",
  },

  overview: {
    title: "🔒 Datenschutz auf einen Blick",
    introduction: "👋 Einleitung",
    controller: "🏢 Wer deine Daten verarbeitet",
    summary: "🔎 Datenschutzübersicht",
    dataWeCollect: "📊 Verarbeitete Daten",
    howWeUseData: "⚙️ Wie wir Daten verwenden",
    legalBases: "⚖️ Warum wir Daten verarbeiten",
    location: "📍 Standortdaten",
    publicContent: "🌐 Öffentliche Inhalte",
    messaging: "💬 Nachrichten",
    cookies: "🍪 Cookies & lokaler Speicher",
    sharing: "🤝 Datenweitergabe",
    transfers: "🌍 Internationale Datenübermittlungen",
    retention: "🗂️ Speicherdauer",
    deletion: "🗑️ Kontolöschung",
    rights: "👤 Deine Datenschutzrechte",
    security: "🔒 Sicherheit",
    changes: "📝 Änderungen",
    contact: "📩 Kontakt",
  },

  introduction: {
    title: "1. Einleitung",
    body: [
      {
        type: "paragraph",
        text:
          "{{appName}} ist eine Social-Media-Plattform, die dazu entwickelt wurde, Menschen miteinander zu verbinden, Inhalte zu teilen, Orte zu entdecken und mit anderen zu interagieren. Der Schutz deiner Privatsphäre ist uns wichtig, und wir verpflichten uns, deine personenbezogenen Daten zu schützen.",
      },
      {
        type: "bullets",
        items: [
          "Diese Datenschutzerklärung erläutert, welche personenbezogenen Daten wir verarbeiten, wie wir sie verwenden, wann wir sie weitergeben können, wie lange wir sie speichern und welche Wahlmöglichkeiten und Rechte dir zur Verfügung stehen.",
          "Der Begriff „Dienst“ bezeichnet {{appName}}, einschließlich der Website, Anwendungen, Funktionen, Funktionen zum Teilen von Inhalten, Nachrichtendienste und zugehörige Plattformdienste.",
          "„Personenbezogene Daten“ sind Informationen, die eine Person identifizieren, sich auf sie beziehen, sie beschreiben oder vernünftigerweise mit ihr in Verbindung gebracht werden können.",
        ],
      },
      {
        type: "paragraph",
        text:
          "Durch die Nutzung von {{appName}} bestätigst du, dass deine personenbezogenen Daten wie in dieser Datenschutzerklärung beschrieben verarbeitet werden können.",
      },
    ],
  },

  controller: {
    title: "2. Wer deine Daten verarbeitet",
    body:
      "{{companyName}} ist für die Verarbeitung deiner personenbezogenen Daten bei der Nutzung des Dienstes verantwortlich.",
  },

  summary: {
    title: "Datenschutzübersicht",
    bullets: [
      "Wir erheben nur Informationen, die für den zuverlässigen Betrieb der Plattform von {{companyName}} erforderlich sind.",
      "Wir verkaufen keine personenbezogenen Daten.",
      "Standortinformationen werden für standortbezogene Funktionen und das Veröffentlichen von Beiträgen verwendet.",
      "Nachrichten werden durch Verschlüsselung und weitere Sicherheitsmaßnahmen geschützt.",
      "Du kannst den Zugriff auf deine personenbezogenen Daten, deren Download, Berichtigung oder Löschung verlangen.",
    ],
  },

  dataWeCollect: {
    title: "4. Von uns verarbeitete Daten",
    body:
      "Welche personenbezogenen Daten wir verarbeiten, hängt davon ab, wie du {{appName}} nutzt und welche Funktionen du aktivierst.",

    providedTitle: "Von dir bereitgestellte Informationen",
    providedBullets: [
      "Kontoinformationen: Informationen, die zum Erstellen und Verwalten deines Kontos erforderlich sind, beispielsweise deine E-Mail-Adresse, dein Profilname und dein Passwort.",
      "Präferenzen und Einstellungen: Datenschutzeinstellungen, Einwilligungsentscheidungen, Benachrichtigungseinstellungen, Spracheinstellungen, Sicherheitseinstellungen und andere Kontoeinstellungen, die du konfigurierst.",
      "Profilinformationen: Informationen, die du deinem Profil freiwillig hinzufügst, beispielsweise ein Profilbild, eine Biografie oder deinen Standort.",
      "Inhalte und Aktivitäten: Fotos, Videos, Beiträge, Likes von Beiträgen, das Folgen anderer Profile, Blockierungen und Meldungen anderer Nutzer sowie weitere Interaktionen innerhalb des Dienstes.",
      "Kommunikation: Nachrichten, Feedback, Supportanfragen, Meldungen oder andere Mitteilungen, die du uns sendest.",
      "Altersbestätigung: Bestätigung, dass du mindestens 18 Jahre alt bist.",
      "Standortdaten: siehe Abschnitt 7 „Standortdaten“.",
    ],

    automaticTitle: "Automatisch erhobene Informationen",
    automaticBullets: [
      "Geräte- und technische Daten: Gerätetyp, Betriebssystem, Browsertyp, App-Version, Spracheinstellungen und vergleichbare technische Informationen.",
      "Protokolldaten: IP-Adresse, Zugriffszeiten, Sicherheitsereignisse, Absturzberichte und Aktivitäten, die für den Betrieb, die Sicherheit und den Schutz des Dienstes erforderlich sind.",
      "Nutzungsdaten: Interaktionen mit Funktionen, Inhalten, Benachrichtigungen, Suchvorgängen und Kontoaktivitäten.",
      "Ungefähre oder genaue Standortdaten: soweit erforderlich, um standortbezogene Funktionen bereitzustellen, und abhängig von deinen Geräteeinstellungen und Berechtigungen; siehe Abschnitt 7 „Standortdaten“.",
    ],

    otherUsersTitle: "Informationen von anderen Nutzern",

otherUsersBullets: [
"Andere Nutzer können mit deinem Profil, deinen Beiträgen, Nachrichten oder Inhalten interagieren.",
"Andere Nutzer können deinem Konto folgen, deine Inhalte mit „Gefällt mir“ markieren, dir Nachrichten senden oder auf andere Weise über den Dienst mit dir interagieren.",
"Andere Nutzer können dein Konto blockieren oder dein Konto, deine Inhalte, Nachrichten oder Aktivitäten zur Überprüfung melden.",
"Meldungen, Beschwerden und Sicherheitsmeldungen können Informationen über dein Konto, deine Inhalte, Nachrichten, die von einem meldenden Nutzer geteilt wurden, oder andere Aktivitäten enthalten.",
],

minorsDataTitle: "Daten von Minderjährigen",

minorsDataBullets: [
"{{appName}} ist ausschließlich für Personen bestimmt, die mindestens 18 Jahre alt sind.",
"Wir erfassen wissentlich keine personenbezogenen Daten von Kindern oder Personen unter dem für die Nutzung des Dienstes erforderlichen Mindestalter.",
"Wenn wir Kenntnis davon erhalten, dass ein Konto von einer Person unter dem erforderlichen Mindestalter erstellt wurde, können wir das Konto sowie die damit verbundenen Informationen sperren, einschränken oder entfernen.",
],
},

howWeUseData: {
title: "5. Wie wir deine Daten verwenden",
body:
"Wir verwenden personenbezogene Daten ausschließlich für legitime und spezifische Zwecke, die mit dem Betrieb von {{appName}} zusammenhängen. Wir bemühen uns, die für den Betrieb der Plattform erforderlichen personenbezogenen Daten auf das notwendige Minimum zu beschränken. Wir verkaufen keine personenbezogenen Daten.",
bullets: [
"**Kontoerstellung und Anmeldung**: zur Erstellung, Authentifizierung, Verwaltung und Absicherung deines Kontos.",
"**Betrieb des Dienstes**: zur Bereitstellung von Beiträgen, Entdecken-Funktionen, Folgen, Likes, Benachrichtigungen, Nachrichten und anderen Funktionen des Dienstes.",
"**Standortfunktionen**: zur Zuordnung von Stadt- und Länderkennzeichnungen zu Beiträgen, zur Unterstützung von Inhalten in der Nähe und zur Bereitstellung standortbezogener Funktionen.",
"**Entdecken-Funktionen**: um Nutzern dabei zu helfen, relevante Inhalte, Orte, Profile und Aktivitäten innerhalb des Dienstes zu entdecken.",
"**Sicherheit, Moderation und Durchsetzung**: zur Überprüfung von Meldungen, Untersuchung von Beschwerden, Durchsetzung unserer Nutzungsbedingungen und Community-Richtlinien, Erkennung schädlicher Aktivitäten sowie zum Ergreifen von Maßnahmen gegen Missbrauch, Spam, Betrug oder Verstöße gegen Richtlinien.",
"**Sicherheit**: zur Verhinderung von Betrug, unbefugtem Zugriff, Spam, Scraping, technischen Angriffen und anderem Missbrauch des Dienstes.",
"**Kommunikation**: zum Versand von kontobezogenen, Support-, rechtlichen, sicherheitsrelevanten und dienstbezogenen Mitteilungen.",
"**Verbesserung des Dienstes**: um zu verstehen, wie Nutzer mit dem Dienst interagieren, und Zuverlässigkeit, Benutzerfreundlichkeit, Funktionalität und Leistung zu verbessern.",
"**Einhaltung gesetzlicher Verpflichtungen**: zur Erfüllung geltender Gesetze, rechtlicher Anfragen, regulatorischer Verpflichtungen und behördlicher Anforderungen.",
],
},

legalBases: {
title: "6. Warum wir Daten verarbeiten",
body:
"Soweit geltende Datenschutzgesetze eine Rechtsgrundlage für die Verarbeitung personenbezogener Daten verlangen, stützen wir uns auf eine oder mehrere der folgenden Rechtsgrundlagen:",

bullets: [
"**Vertrag**: zur Bereitstellung, zum Betrieb und zur Verwaltung von Konten, Nachrichten, Beiträgen, Entdecken-Funktionen und anderen von dir angeforderten oder genutzten Funktionen.",
"**Einwilligung**: für optionale Funktionen, Berechtigungen oder Verarbeitungsvorgänge, bei denen deine Einwilligung erforderlich ist.",
"**Gesetzliche Verpflichtung**: zur Einhaltung geltender Gesetze, Vorschriften, rechtlicher Anfragen, gerichtlicher Anordnungen und behördlicher Anforderungen.",
"**Berechtigte Interessen**: zur Aufrechterhaltung der Sicherheit, Verhinderung von Missbrauch, Untersuchung von Meldungen, Verbesserung des Dienstes, Schutz der Nutzer und zum effektiven Betrieb der Plattform.",
"**Schutz lebenswichtiger Interessen**: soweit erforderlich, um die Sicherheit, Rechte, Gesundheit oder das Wohlergehen von Nutzern oder anderen Personen zu schützen.",
],
},

location: {
title: "7. Standortdaten",

body:
"{{appName}} umfasst standortbezogene Funktionen. Standortinformationen werden verwendet, um das Teilen von Inhalten, Entdecken-Funktionen, Inhalte in der Nähe sowie Standortkennzeichnungen für Beiträge zu unterstützen.",

bullets: [
"Zum Erstellen eines Beitrags ist zum Zeitpunkt der Veröffentlichung der Zugriff auf den Standort erforderlich, da Beiträge mit einer Stadt- und Länderkennzeichnung versehen werden.",
"Standortkennzeichnungen beziehen sich auf Städte, Länder oder ähnliche geografische Bezeichnungen, die einem Beitrag zugeordnet sind.",
"Wir verwenden den Standort deines Geräts, um die einem Beitrag zugeordnete Stadt- und Länderkennzeichnung zu bestimmen und anzuzeigen.",
"Standortinformationen können verwendet werden, um Inhalte in der Nähe und Entdecken-Funktionen innerhalb des Dienstes bereitzustellen.",
"Standortberechtigungen werden über das Betriebssystem deines Geräts angefordert.",
"Wenn Standortberechtigungen verweigert oder deaktiviert werden, funktionieren das Veröffentlichen von Inhalten und bestimmte standortbezogene Funktionen möglicherweise nicht ordnungsgemäß.",
"Wir verwenden Standortdaten nicht für Werbung Dritter.",
],

note:
"Präzise Standortdaten werden nur so lange gespeichert, wie dies erforderlich ist, um standortbezogene Funktionen bereitzustellen, die Sicherheit aufrechtzuerhalten, gesetzlichen Verpflichtungen nachzukommen oder technische Abläufe zu unterstützen.",
},

publicContent: {
title: "8. Öffentliche Inhalte",

body:
"{{appName}} ist eine soziale Plattform. Bestimmte Informationen und Inhalte, die du teilst, können je nach Funktionsweise des Dienstes und den Sichtbarkeitseinstellungen des Inhalts für andere Nutzer sichtbar sein.",

bullets: [
"Öffentliche Beiträge, Fotos, Videos, Profilinformationen und Standortkennzeichnungen, die mit Beiträgen verbunden sind, können für andere Nutzer sichtbar sein.",
"Andere Nutzer können deine öffentlichen Inhalte ansehen, mit „Gefällt mir“ markieren, dir folgen, sie melden oder anderweitig mit ihnen interagieren.",
"Öffentliche Inhalte können sichtbar bleiben, bis sie gelöscht oder aus dem Dienst entfernt werden.",
"Wenn Inhalte von anderen Nutzern kopiert, geteilt, heruntergeladen, per Screenshot gespeichert oder anderweitig gesichert werden, können wir möglicherweise nicht jede externe Kopie entfernen.",
"Dein Profilname, Profilbild und eingeschränkte Profilinformationen können im Zusammenhang mit Beiträgen, Nachrichten, Benachrichtigungen, Followern, Likes, Meldungen oder anderen Interaktionen innerhalb des Dienstes angezeigt werden.",
],
},

messaging: {
title: "9. Nachrichten",

body:
"{{appName}} umfasst private Nachrichtenfunktionen, die es Nutzern ermöglichen, direkt miteinander zu kommunizieren. Wir verwenden Verschlüsselung sowie weitere technische und organisatorische Maßnahmen, um Nachrichten und zugehörige Daten zu schützen.",

bullets: [
"Nachrichten werden durch Verschlüsselung und weitere Sicherheitsmaßnahmen geschützt, die den Schutz der Nachrichteninhalte während der Speicherung und Übertragung gewährleisten sollen.",
"Verschlüsselungsschlüssel und damit verbundene Sicherheitsinformationen können verarbeitet werden, um eine sichere Nachrichtenfunktion bereitzustellen.",
"Nachrichtenbezogene Metadaten können Absender- und Empfängerkennungen, Konversationskennungen, Zeitstempel, Informationen zum Zustellstatus sowie technische Informationen umfassen, die für den Betrieb des Nachrichtendienstes erforderlich sind.",
"Nutzer können von ihnen gesendete Nachrichten löschen. Wird eine Nachricht in einem aktiven Chat gelöscht, wird sie aus der Ansicht beider Teilnehmer entfernt.",
"Wenn ein Nutzer sein Konto löscht, können Unterhaltungen für andere Teilnehmer weiterhin verfügbar bleiben; identifizierende Kontoinformationen können jedoch entfernt oder anonymisiert werden.",
"Wir speichern Nachrichtendaten nur so lange, wie dies für den Betrieb des Dienstes, die Aufrechterhaltung der Sicherheit, die Einhaltung gesetzlicher Verpflichtungen und die Durchsetzung unserer Richtlinien erforderlich ist."
],

note:
"Obwohl wir Verschlüsselung und Sicherheitsmaßnahmen zum Schutz von Nachrichten einsetzen, kann kein Nachrichtensystem unter allen Umständen absolute Sicherheit garantieren.",
},


cookies: {
title: "10. Cookies & Lokaler Speicher",

body:
"{{appName}} kann Cookies, lokalen Speicher, Sitzungsspeicher, Authentifizierungstokens und ähnliche Technologien verwenden, soweit dies erforderlich ist, um den Dienst bereitzustellen, zu sichern, zu warten und zu betreiben.",

bullets: [
"Authentifizierungstechnologien können verwendet werden, um dich angemeldet zu halten und Kontositzungen zu verwalten.",
"Sicherheitsbezogene Technologien können eingesetzt werden, um Betrug, Missbrauch, unbefugten Zugriff und andere schädliche Aktivitäten zu verhindern.",
"Einstellungen können gespeichert werden, um Sprache, Anzeigeoptionen, Barrierefreiheit und andere Benutzereinstellungen zu speichern.",
"Bestimmte technische Speichermechanismen können für die Kernfunktionen, Leistung, Zuverlässigkeit und Sicherheit des Dienstes erforderlich sein.",
"Wir verwenden keine Cookies oder ähnlichen Technologien von Drittanbietern für Werbezwecke Dritter."
],
},

sharing: {
title: "11. Weitergabe von Daten",

body:
"Wir verkaufen keine personenbezogenen Daten. Personenbezogene Daten werden nur weitergegeben, soweit dies angemessen erforderlich ist, um {{appName}} zu betreiben, zu sichern, zu schützen, zu unterstützen oder rechtmäßig bereitzustellen.",

bullets: [
"**Dienstleister**: vertrauenswürdige Anbieter, die Hosting, Cloud-Infrastruktur, Inhaltsbereitstellung, Speicherung, Sicherheit, Kommunikation, Analysen und andere betriebliche Dienstleistungen unterstützen.",
"**Gesetzliche Verpflichtungen**: soweit dies nach geltendem Recht, aufgrund rechtlicher Verfahren, gerichtlicher Anordnungen, behördlicher Anfragen oder staatlicher Anforderungen erforderlich ist.",
"**Sicherheit und Schutz**: soweit dies erforderlich ist, um Nutzer zu schützen, Missbrauch zu untersuchen, unsere Richtlinien durchzusetzen, Betrug zu verhindern oder auf Sicherheitsrisiken zu reagieren.",
"**Unternehmenstransaktionen**: im Zusammenhang mit einer Fusion, Übernahme, Finanzierung, Umstrukturierung, Veräußerung von Vermögenswerten oder einer ähnlichen Unternehmenstransaktion von {{companyName}}.",
"**Auf deine Anweisung**: wenn du Inhalte teilst, mit anderen Nutzern interagierst, über den Dienst kommunizierst oder öffentliche Funktionen nutzt."
],

noSale:
"{{companyName}} verkauft keine personenbezogenen Daten und verwendet personenbezogene Daten nicht für Werbezwecke Dritter.",
},

transfers: {
title: "12. Internationale Datenübermittlungen",

body:
"Personenbezogene Daten können in Ländern außerhalb deines Wohnsitzlandes verarbeitet oder gespeichert werden, unter anderem durch die Nutzung von Cloud-Infrastrukturen, Hosting-Anbietern und anderen Dienstleistern. Soweit dies nach geltendem Recht erforderlich ist, treffen wir angemessene Maßnahmen, um sicherzustellen, dass personenbezogene Daten ein angemessenes Schutzniveau erhalten.",
},

retention: {
title: "13. Datenspeicherung",

body:
"Wir speichern personenbezogene Daten nur so lange, wie dies für die in dieser Datenschutzerklärung beschriebenen Zwecke erforderlich ist, sofern keine längere Aufbewahrungsfrist gesetzlich vorgeschrieben oder zulässig ist.",

bullets: [
"**Kontodaten**: werden gespeichert, solange dein Konto aktiv ist, und für einen begrenzten Zeitraum nach der Löschung, soweit dies aus rechtlichen, sicherheitsrelevanten, betrugspräventiven oder technischen Gründen erforderlich ist.",
"**Öffentliche Beiträge**: werden gespeichert, bis sie von dir gelöscht, von uns entfernt oder zusammen mit deinem Konto gelöscht werden, vorbehaltlich von Backups, gesetzlichen Verpflichtungen oder Moderationsanforderungen.",
"**Nachrichten**: werden gespeichert, soweit dies für die Bereitstellung der Nachrichtenfunktion erforderlich ist. Unterhaltungen können für andere Teilnehmer weiterhin verfügbar bleiben, sofern sie nicht gelöscht, anonymisiert oder entsprechend der Funktionalität des Dienstes technisch entfernt werden.",
"**Standortkennzeichnungen**: Stadt- und Länderkennzeichnungen, die Beiträgen zugeordnet sind, können verfügbar bleiben, solange der betreffende Beitrag verfügbar ist.",
"**Sicherheitsprotokolle**: werden für begrenzte Zeiträume gespeichert, um die Sicherheit zu gewährleisten, Vorfälle zu untersuchen, Betrug zu verhindern und den Dienst zu schützen.",
"**Meldungen und Moderationsaufzeichnungen**: werden gespeichert, soweit dies erforderlich ist, um Meldungen zu prüfen, unsere Nutzungsbedingungen und Community-Richtlinien durchzusetzen, wiederholten Missbrauch zu verhindern und gesetzlichen Verpflichtungen nachzukommen.",
"**Backups**: Gelöschte Daten können für einen begrenzten Zeitraum in Sicherungssystemen verbleiben, bevor sie überschrieben, entfernt oder sicher vernichtet werden."
],
},

deletion: {
title: "14. Kontolöschung",

body:
"Du kannst die Löschung deines Kontos und deiner personenbezogenen Daten über den im Dienst bereitgestellten Kontolöschungsprozess beantragen. Nach der Löschung deines Kontos werden die damit verbundenen personenbezogenen Daten grundsätzlich gelöscht. Bestimmte Informationen können jedoch aufbewahrt, anonymisiert oder von deinem Konto getrennt werden, soweit dies zur Einhaltung gesetzlicher Verpflichtungen, zur Sicherheit, Betrugsprävention, Streitbeilegung, für technische Abläufe oder aufgrund von Backup-Anforderungen erforderlich ist.",

bullets: [
"Dein Konto, deine Profilinformationen und dein Zugriff auf den Dienst können entfernt, gelöscht, anonymisiert oder deaktiviert werden.",
"Mit deinem Konto verbundene Inhalte können gelöscht, entfernt, anonymisiert oder von deinem Konto getrennt werden, vorbehaltlich technischer, rechtlicher, sicherheitsrelevanter, moderationsbezogener oder backupbedingter Anforderungen.",
"Nachrichten und Unterhaltungen mit anderen Nutzern können diesen weiterhin zur Verfügung stehen; Informationen, die dein Konto identifizieren, können jedoch entfernt, anonymisiert oder ersetzt werden.",
"Nachrichten können nur über die im Dienst bereitgestellte aktive Nachrichtenfunktion aus der Ansicht beider Teilnehmer entfernt werden.",
"Bestimmte Aufzeichnungen können aufbewahrt werden, soweit dies zur Einhaltung gesetzlicher Verpflichtungen, Streitbeilegung, Betrugsprävention, Missbrauchsprävention, Sicherheit oder zur Durchsetzung unserer Nutzungsbedingungen und Community-Richtlinien erforderlich ist.",
"Backup-Kopien können für einen begrenzten Zeitraum bestehen bleiben, bevor sie im Rahmen der üblichen Backup-Aufbewahrungsprozesse überschrieben, entfernt oder sicher vernichtet werden."
],
},

rights: {
title: "15. Deine Datenschutzrechte",

body:
"Abhängig von deinem Wohnort, den geltenden Gesetzen und der Art der Datenverarbeitung stehen dir möglicherweise bestimmte Rechte in Bezug auf deine personenbezogenen Daten zu.",

bullets: [
"Recht auf Auskunft über die personenbezogenen Daten, die wir über dich gespeichert haben.",
"Recht auf Berichtigung unrichtiger, unvollständiger oder veralteter personenbezogener Daten.",
"Recht auf Löschung personenbezogener Daten, vorbehaltlich geltender gesetzlicher, sicherheitsrelevanter und betrieblicher Anforderungen.",
"Recht auf Einschränkung oder Widerspruch gegen bestimmte Verarbeitungsvorgänge.",
"Recht auf Erhalt einer Kopie deiner personenbezogenen Daten.",
"Recht, eine Einwilligung für optionale Verarbeitungsvorgänge, beispielsweise bestimmte Standort- oder Geräteberechtigungen, jederzeit zu widerrufen.",
"Recht, Informationen darüber zu verlangen, wie deine personenbezogenen Daten verarbeitet werden.",
"Recht, gegebenenfalls Beschwerde bei einer zuständigen Datenschutzaufsichtsbehörde einzureichen."
],

contactPrefix:
"Um deine Datenschutzrechte auszuüben oder Fragen zu dieser Datenschutzerklärung zu stellen, kontaktiere uns unter",

or: "oder",
},

security: {
title: "16. Sicherheit",

body:
"Wir setzen Sicherheitsmaßnahmen ein, die dazu dienen, personenbezogene Daten zu schützen. Dennoch kann keine Methode der Übertragung, Speicherung oder Sicherheitsmaßnahme absolute Sicherheit garantieren.",

bullets: [
"Zu den Sicherheitsmaßnahmen können Verschlüsselung, Authentifizierungskontrollen, Überwachung, Zugriffsbeschränkungen und weitere Schutzmaßnahmen gehören.",
"Sicherheitsfunktionen und Schutzmaßnahmen können sich im Zuge der Weiterentwicklung des Dienstes ändern.",
"Nutzer sind selbst dafür verantwortlich, die Sicherheit ihrer Konten, Zugangsdaten, Geräte und der mit dem Dienst verbundenen E-Mail-Konten zu gewährleisten. Passwörter dürfen nicht weitergegeben werden und sollten geheim gehalten werden."
],
},

changes: {
title: "17. Änderungen dieser Datenschutzerklärung",

body:
"Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren, um Änderungen am Dienst, an unseren Praktiken, gesetzlichen Anforderungen oder anderen betrieblichen Erfordernissen Rechnung zu tragen. Wenn wir wesentliche Änderungen vornehmen, können wir dich – soweit angemessen – über den Dienst, per E-Mail oder auf anderem geeigneten Weg darüber informieren. Die aktualisierte Version tritt an dem unter „Zuletzt aktualisiert“ am Anfang dieser Datenschutzerklärung angegebenen Datum in Kraft.",

bullets: [
"Aktualisierungen können erfolgen, um neue Funktionen, Funktionalitäten, Produkte oder Dienstleistungen des Dienstes zu berücksichtigen.",
"Wir können diese Datenschutzerklärung anpassen, um Änderungen geltender Gesetze, Vorschriften oder behördlicher Leitlinien zu entsprechen.",
"Wesentliche Änderungen, die die Erhebung, Nutzung, Offenlegung oder den Schutz personenbezogener Daten betreffen, können über den Dienst oder andere Kommunikationskanäle hervorgehoben werden.",
"Die im Dienst veröffentlichte Version ist die aktuelle und maßgebliche Version dieser Datenschutzerklärung.",
"Wir empfehlen dir, diese Datenschutzerklärung regelmäßig zu lesen, damit du über unsere Datenschutzpraktiken informiert bleibst."
],

note:
"Wenn du einer überarbeiteten Version dieser Datenschutzerklärung nicht zustimmst, kannst du die Nutzung des Dienstes einstellen und die Löschung deines Kontos sowie deiner personenbezogenen Daten beantragen, vorbehaltlich unserer gesetzlichen und regulatorischen Verpflichtungen."
},

contact: {
title: "18. Kontakt",
body:
"{{companyName}}\n{{companyAddress}}\n{{contactEmail}}",
},

 },
} as const;




export default privacyPolicy;